import * as actionTypes from '../actions/actionTypes';

const initialState = {
    title : 'My Game',
    lang : "en"
};

const headerReducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.SET_HEADER_TITLE : return {...state, ...action.payLoad }
        case actionTypes.CHANGE_LANGUAGE : return {...state, ...action.payLoad }
        default:
            return state;
    }
};

export default headerReducer;


/** WEBPACK FOOTER **
 ** ./src/store/reducer/headerReducer.js
 **/